import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import validator from 'validator';
import { Table, Input, Icon } from "semantic-ui-react";
import { updateLineOfModel,
    deleteLineOfUnsavedModel,
    deleteLineOfSavedModel,
} from "../../../actions/order";

class OrderLineForm extends Component {
    constructor() {
        super();
        this.state = {
            quantity_error: false,
            price_error: false,
            loading: false
        };
    }

    onUomChange = (value) => {
        const {id} = this.props.line;
        this.props.updateLineOfModel(id, 'uom', value);
    }

    onQuantityChange = (value) => {
        if (this.checkQuantityInput(value)) {
            this.setState({
                quantity_error: false
            })
        } else {
            this.setState({
                quantity_error: true
            })
        }
        const {id} = this.props.line;
        this.props.updateLineOfModel(id, 'quantity', value);
    }

    onPriceChange = (value) => {
        if (this.checkPriceInput(value)) {
            this.setState({
                price_error: false
            })
        } else {
            this.setState({
                price_error: true
            })
        }
        const {id} = this.props.line;
        this.props.updateLineOfModel(id, 'price', value);
    }

    checkPriceInput = (value) => {
        if (!validator.isNumeric(value)) {
            return false;
        }
        if (parseFloat(value) < 0) {
            return false;
        }
        return true;
    }

    checkQuantityInput = (value) => {
        if (!validator.isInt(value)) {
            return false;
        }
        if (parseInt(value) <= 0) {
            return false;
        }
        return true;
    }

    onDeleteClick = () => {
        const {jwt, line} = this.props;
        if (_.isNaN(parseInt(line.id))) {
            //Unsaved Lines
            this.props.deleteLineOfUnsavedModel(line.id);
        } else {
            this.props.deleteLineOfSavedModel(jwt, line);
        }
    }

    getAvailable = () => {
        const {warehouseId} = this.props;
        const {qty_warehouse_instock, qty_warehouse_reserved, type} = this.props.line.inventory;
        if (type !== 'Inventory') {
            return 'NA'
        }
        let reserved = 0;
        let instock = 0;
        if (_.isArray(qty_warehouse_instock)) {
            _.each(qty_warehouse_instock, instockRecord => {
                if (_.toInteger(warehouseId) === _.toInteger(instockRecord.warehouse_id)) {
                    instock = parseInt(instockRecord.instock);
                }
            });
        }
        if (_.isArray(qty_warehouse_reserved)) {
            _.each(qty_warehouse_reserved, reservedRecord => {
                if (_.toInteger(warehouseId) === _.toInteger(reservedRecord.warehouse_id)) {
                    reserved = Math.abs(_.toInteger(reservedRecord.reserve));
                }
            });
        }

        return instock - reserved;
    }
    
    render() {
        const {line, isMobile} = this.props;
        const {inventory} = line;
        return (
            <Table.Row>
                <Table.Cell>
                    {inventory.sku}
                    {line.special_sku ? ` (${line.special_sku})`: null}
                </Table.Cell>
                <Table.Cell>
                    {inventory.name}
                    {line.special_name ? ` (${line.special_name})`: null}
                </Table.Cell>
                <Table.Cell>
                    {inventory.upc}
                </Table.Cell>
                <Table.Cell>
                    {isMobile ? "UOM: " : null}
                    <Input 
                        value={line.uom} size='mini' onChange={(e, {value}) => this.onUomChange(value) }/>
                </Table.Cell>
                <Table.Cell className={this.state.price_error ? 'error-cell':null}>
                    {isMobile ? "Price: " : null}
                    <Input 
                        icon='dollar sign' iconPosition='left' type="number"
                        value={Math.round(line.price * 100) / 100} size='mini' onChange={(e, {value}) => this.onPriceChange(value) }/>
                </Table.Cell>
                <Table.Cell className={this.state.quantity_error ? 'error-cell':null}>
                    {isMobile ? "Qty: " : null}
                    <Input value={line.quantity} size='mini' type="number"
                        onChange={(e, {value}) => this.onQuantityChange(value) }/>
                </Table.Cell>
                <Table.Cell>
                    {isMobile ? "Stock: " : null}
                    {this.getAvailable()}
                </Table.Cell>
                <Table.Cell>
                    <a onClick={() => this.onDeleteClick()}>
                        {isMobile ? "Delete" : <Icon name='delete' />}
                    </a>
                </Table.Cell>
            </Table.Row>
        );
    }
}

OrderLineForm.propTypes = {
    updateLineOfModel: PropTypes.func.isRequired,
    deleteLineOfUnsavedModel: PropTypes.func.isRequired,
    deleteLineOfSavedModel: PropTypes.func.isRequired,
    line: PropTypes.shape({
        inventory: PropTypes.object.isRequired
    }).isRequired,
    jwt: PropTypes.string.isRequired,
    warehouseId: PropTypes.string.isRequired,
    isMobile: PropTypes.any
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            updateLineOfModel,
            deleteLineOfUnsavedModel,
            deleteLineOfSavedModel
        },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderLineForm);



// WEBPACK FOOTER //
// ./src/components/forms/orders/OrderLine.js